export default __webpack_public_path__ + "static/Bigjerryfencing-5ad92717cdffa31f405a3d1e80922297.jpg";